<template>
    <div class="created_company_store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!-- <li class="breadcrumb-item"><a href="#">Cart</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Company Store 2
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="store_banner mt_20">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="created_team_banner">
                            <img
                                src="/maincss/images/champion_logo.png"
                                alt="img"
                            />
                            <h2>St Regis</h2>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum has been
                                the industry’s standard dummy text ever since
                                the 1500s,
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="cmn-section item-category-list created_team_cmn_sec">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-4 col-xl-3">
                        <div class="side_bar filter">
                            <div
                                class="serach view_by_select_box d-flex ml-auto position-relative"
                            >
                                <label>View By</label>
                                <select name="" id="">
                                    <option value="" selected>All</option>
                                    <option value="">1</option>
                                    <option value="">1</option>
                                    <option value="">1</option>
                                </select>
                            </div>
                            <div class="categorys">
                                <div id="accordionExample" class="accordion">
                                    <div id="brand_link">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#brands_div"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center"
                                        >
                                            <span>Brands</span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="brands_div"
                                            aria-labelledby="brands_div"
                                            class="category_checkbox_show collapse show"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >A4
                                                        <input
                                                            id="30"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="30" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Adidas
                                                        <input
                                                            id="33"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="33" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Augusta Sportswear
                                                        <input
                                                            id="36"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="36" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Badger Sports
                                                        <input
                                                            id="43"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="43" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Champion
                                                        <input
                                                            id="39"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="39" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >FlexFit
                                                        <input
                                                            id="28"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="28" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Gildan
                                                        <input
                                                            id="31"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="31" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Hanes
                                                        <input
                                                            id="52"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="52" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >High5Five
                                                        <input
                                                            id="34"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="34" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Holloway
                                                        <input
                                                            id="37"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="37" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >JERZEES
                                                        <input
                                                            id="50"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="50" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Jockey
                                                        <input
                                                            id="53"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="53" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >New Era
                                                        <input
                                                            id="44"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="44" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Nike
                                                        <input
                                                            id="40"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="40" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >OGIO
                                                        <input
                                                            id="32"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="32" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Pacific headwear
                                                        <input
                                                            id="35"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="35" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Port &amp; company
                                                        <input
                                                            id="45"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="45" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Richardson
                                                        <input
                                                            id="38"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="38" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Russel Athletic
                                                        <input
                                                            id="41"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="41" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Sport-Tek
                                                        <input
                                                            id="42"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="42" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Test
                                                        <input
                                                            id="49"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="49" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >The North Face
                                                        <input
                                                            id="29"
                                                            type="checkbox"
                                                            name="brands"
                                                            value="29" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style=""
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="gender_age_1_link_1">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#gender_age_1"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center collapsed"
                                        >
                                            <span>Gender/Age</span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="gender_age_1"
                                            aria-labelledby="gender_age_1"
                                            class="category_checkbox_show collapsed collapse"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >ADTL
                                                        <input
                                                            id="ADTL"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="15" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Adult Sizes: XS-4XL
                                                        <input
                                                            id="Adult Sizes: XS-4XL"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="26" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >GRL
                                                        <input
                                                            id="GRL"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="19" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Ladies - Pc55L
                                                        <input
                                                            id="Ladies - Pc55L"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="27" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >MNUS
                                                        <input
                                                            id="MNUS"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="16" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >New size Group
                                                        <input
                                                            id="New size Group"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="28" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Promos
                                                        <input
                                                            id="Promos"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="30" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >TDLR
                                                        <input
                                                            id="TDLR"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="20" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Youth
                                                        <input
                                                            id="Youth"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="29" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Youth-PCL
                                                        <input
                                                            id="Youth-PCL"
                                                            type="checkbox"
                                                            name="genderage"
                                                            value="18" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style=""
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="sleeve-div_link_1">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#sleeve-div"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center collapsed"
                                        >
                                            <span> Sleeve </span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="sleeve-div"
                                            aria-labelledby="sleeve-div"
                                            class="category_checkbox_show collapsed collapse"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >3/4 Sleeve
                                                        <input
                                                            type="checkbox"
                                                            id="3"
                                                            name="sleevesId"
                                                            value="3" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Cap Sleeve
                                                        <input
                                                            type="checkbox"
                                                            id="4"
                                                            name="sleevesId"
                                                            value="4" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Long Sleeve
                                                        <input
                                                            type="checkbox"
                                                            id="2"
                                                            name="sleevesId"
                                                            value="2" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Raglan Sleeve
                                                        <input
                                                            type="checkbox"
                                                            id="6"
                                                            name="sleevesId"
                                                            value="6" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Short Sleeve
                                                        <input
                                                            type="checkbox"
                                                            id="1"
                                                            name="sleevesId"
                                                            value="1" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Sleeveless
                                                        <input
                                                            type="checkbox"
                                                            id="5"
                                                            name="sleevesId"
                                                            value="5" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Tank
                                                        <input
                                                            type="checkbox"
                                                            id="8"
                                                            name="sleevesId"
                                                            value="8" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Test
                                                        <input
                                                            type="checkbox"
                                                            id="11"
                                                            name="sleevesId"
                                                            value="11" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Thumb hole
                                                        <input
                                                            type="checkbox"
                                                            id="7"
                                                            name="sleevesId"
                                                            value="7" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style=""
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="style_link_1">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#style-div"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center collapsed"
                                        >
                                            <span> Style </span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="style-div"
                                            aria-labelledby="style-div"
                                            class="category_checkbox_show collapse"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        3 in 1
                                                        <input
                                                            type="checkbox"
                                                            id="34"
                                                            name="styles"
                                                            value="3 in 1" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        5-panel
                                                        <input
                                                            type="checkbox"
                                                            id="37"
                                                            name="styles"
                                                            value="5-panel" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        6-panel
                                                        <input
                                                            type="checkbox"
                                                            id="36"
                                                            name="styles"
                                                            value="6-panel" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Backpacks
                                                        <input
                                                            type="checkbox"
                                                            id="51"
                                                            name="styles"
                                                            value="Backpacks" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Beach Tote
                                                        <input
                                                            type="checkbox"
                                                            id="60"
                                                            name="styles"
                                                            value="Beach Tote" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Blankets
                                                        <input
                                                            type="checkbox"
                                                            id="64"
                                                            name="styles"
                                                            value="Blankets" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Bottle
                                                        <input
                                                            type="checkbox"
                                                            id="70"
                                                            name="styles"
                                                            value="Bottle" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        BriefcaseMessenger
                                                        <input
                                                            type="checkbox"
                                                            id="54"
                                                            name="styles"
                                                            value="BriefcaseMessenger" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Buckle Closure
                                                        <input
                                                            type="checkbox"
                                                            id="44"
                                                            name="styles"
                                                            value="Buckle Closure" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Cinch Packs
                                                        <input
                                                            type="checkbox"
                                                            id="57"
                                                            name="styles"
                                                            value="Cinch Packs" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Coolers &amp; Lunch
                                                        <input
                                                            type="checkbox"
                                                            id="58"
                                                            name="styles"
                                                            value="Coolers &amp; Lunch" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Crew-neck
                                                        <input
                                                            type="checkbox"
                                                            id="3"
                                                            name="styles"
                                                            value="Crew-neck" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Cuff Bottom
                                                        <input
                                                            type="checkbox"
                                                            id="17"
                                                            name="styles"
                                                            value="Cuff Bottom" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Duffels
                                                        <input
                                                            type="checkbox"
                                                            id="52"
                                                            name="styles"
                                                            value="Duffels" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Fitted
                                                        <input
                                                            type="checkbox"
                                                            id="45"
                                                            name="styles"
                                                            value="Fitted" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Flat Bill
                                                        <input
                                                            type="checkbox"
                                                            id="41"
                                                            name="styles"
                                                            value="Flat Bill" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Fleece
                                                        <input
                                                            type="checkbox"
                                                            id="30"
                                                            name="styles"
                                                            value="Fleece" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Fleece with Pocket
                                                        <input
                                                            type="checkbox"
                                                            id="13"
                                                            name="styles"
                                                            value="Fleece with Pocket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Fleece without Pocket
                                                        <input
                                                            type="checkbox"
                                                            id="14"
                                                            name="styles"
                                                            value="Fleece without Pocket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Flexfit
                                                        <input
                                                            type="checkbox"
                                                            id="38"
                                                            name="styles"
                                                            value="Flexfit" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Game
                                                        <input
                                                            type="checkbox"
                                                            id="28"
                                                            name="styles"
                                                            value="Game" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Gloves
                                                        <input
                                                            type="checkbox"
                                                            id="65"
                                                            name="styles"
                                                            value="Gloves" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Golf
                                                        <input
                                                            type="checkbox"
                                                            id="56"
                                                            name="styles"
                                                            value="Golf" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Golf Outerwear
                                                        <input
                                                            type="checkbox"
                                                            id="35"
                                                            name="styles"
                                                            value="Golf Outerwear" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Grocery Tote
                                                        <input
                                                            type="checkbox"
                                                            id="59"
                                                            name="styles"
                                                            value="Grocery Tote" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        High Profile
                                                        <input
                                                            type="checkbox"
                                                            id="48"
                                                            name="styles"
                                                            value="High Profile" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Hip Pack
                                                        <input
                                                            type="checkbox"
                                                            id="63"
                                                            name="styles"
                                                            value="Hip Pack" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Insulated
                                                        <input
                                                            type="checkbox"
                                                            id="31"
                                                            name="styles"
                                                            value="Insulated" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Jogger
                                                        <input
                                                            type="checkbox"
                                                            id="15"
                                                            name="styles"
                                                            value="Jogger" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Laundry Bag
                                                        <input
                                                            type="checkbox"
                                                            id="61"
                                                            name="styles"
                                                            value="Laundry Bag" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Length
                                                        <input
                                                            type="checkbox"
                                                            id="20"
                                                            name="styles"
                                                            value="Length" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Low Profile
                                                        <input
                                                            type="checkbox"
                                                            id="46"
                                                            name="styles"
                                                            value="Low Profile" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Mesh
                                                        <input
                                                            type="checkbox"
                                                            id="25"
                                                            name="styles"
                                                            value="Mesh" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Mid Profile
                                                        <input
                                                            type="checkbox"
                                                            id="47"
                                                            name="styles"
                                                            value="Mid Profile" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Nylon Jacket
                                                        <input
                                                            type="checkbox"
                                                            id="23"
                                                            name="styles"
                                                            value="Nylon Jacket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Open Bottom
                                                        <input
                                                            type="checkbox"
                                                            id="16"
                                                            name="styles"
                                                            value="Open Bottom" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Patterned/Camo
                                                        <input
                                                            type="checkbox"
                                                            id="39"
                                                            name="styles"
                                                            value="Patterned/Camo" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Practive
                                                        <input
                                                            type="checkbox"
                                                            id="27"
                                                            name="styles"
                                                            value="Practive" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Racer-back
                                                        <input
                                                            type="checkbox"
                                                            id="7"
                                                            name="styles"
                                                            value="Racer-back" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Raglan
                                                        <input
                                                            type="checkbox"
                                                            id="6"
                                                            name="styles"
                                                            value="Raglan" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Rainwear
                                                        <input
                                                            type="checkbox"
                                                            id="32"
                                                            name="styles"
                                                            value="Rainwear" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Reversible
                                                        <input
                                                            type="checkbox"
                                                            id="24"
                                                            name="styles"
                                                            value="Reversible" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Sandwich Bill
                                                        <input
                                                            type="checkbox"
                                                            id="40"
                                                            name="styles"
                                                            value="Sandwich Bill" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Scarves
                                                        <input
                                                            type="checkbox"
                                                            id="66"
                                                            name="styles"
                                                            value="Scarves" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Scoop Neck
                                                        <input
                                                            type="checkbox"
                                                            id="2"
                                                            name="styles"
                                                            value="Scoop Neck" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Short with Pocket
                                                        <input
                                                            type="checkbox"
                                                            id="18"
                                                            name="styles"
                                                            value="Short with Pocket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Short without pocket
                                                        <input
                                                            type="checkbox"
                                                            id="19"
                                                            name="styles"
                                                            value="Short without pocket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Snapback Closure
                                                        <input
                                                            type="checkbox"
                                                            id="42"
                                                            name="styles"
                                                            value="Snapback Closure" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Soft Shell
                                                        <input
                                                            type="checkbox"
                                                            id="29"
                                                            name="styles"
                                                            value="Soft Shell" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Structured
                                                        <input
                                                            type="checkbox"
                                                            id="49"
                                                            name="styles"
                                                            value="Structured" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Toiletry Bag
                                                        <input
                                                            type="checkbox"
                                                            id="62"
                                                            name="styles"
                                                            value="Toiletry Bag" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Totes
                                                        <input
                                                            type="checkbox"
                                                            id="53"
                                                            name="styles"
                                                            value="Totes" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Towels
                                                        <input
                                                            type="checkbox"
                                                            id="67"
                                                            name="styles"
                                                            value="Towels" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Track Jacket
                                                        <input
                                                            type="checkbox"
                                                            id="22"
                                                            name="styles"
                                                            value="Track Jacket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Travel
                                                        <input
                                                            type="checkbox"
                                                            id="55"
                                                            name="styles"
                                                            value="Travel" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Unstructered
                                                        <input
                                                            type="checkbox"
                                                            id="50"
                                                            name="styles"
                                                            value="Unstructered" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        UV Protection
                                                        <input
                                                            type="checkbox"
                                                            id="26"
                                                            name="styles"
                                                            value="UV Protection" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        V-Neck
                                                        <input
                                                            type="checkbox"
                                                            id="1"
                                                            name="styles"
                                                            value="V-Neck" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Velcro Closure
                                                        <input
                                                            type="checkbox"
                                                            id="43"
                                                            name="styles"
                                                            value="Velcro Closure" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Vest
                                                        <input
                                                            type="checkbox"
                                                            id="33"
                                                            name="styles"
                                                            value="Vest" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Wind Breaker
                                                        <input
                                                            type="checkbox"
                                                            id="21"
                                                            name="styles"
                                                            value="Wind Breaker" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        With drawstrings
                                                        <input
                                                            type="checkbox"
                                                            id="12"
                                                            name="styles"
                                                            value="With drawstrings" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        With hood
                                                        <input
                                                            type="checkbox"
                                                            id="4"
                                                            name="styles"
                                                            value="With hood" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        With pocket
                                                        <input
                                                            type="checkbox"
                                                            id="8"
                                                            name="styles"
                                                            value="With pocket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        With snap buttons
                                                        <input
                                                            type="checkbox"
                                                            id="11"
                                                            name="styles"
                                                            value="With snap buttons" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        With zipper
                                                        <input
                                                            type="checkbox"
                                                            id="10"
                                                            name="styles"
                                                            value="With zipper" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Without hood
                                                        <input
                                                            type="checkbox"
                                                            id="5"
                                                            name="styles"
                                                            value="Without hood" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Without pocket
                                                        <input
                                                            type="checkbox"
                                                            id="9"
                                                            name="styles"
                                                            value="Without pocket" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Zzzzzzzzzzz
                                                        <input
                                                            type="checkbox"
                                                            id="69"
                                                            name="styles"
                                                            value="zzzzzzzzzzz" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style=""
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="fabric_link_1">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#fabric_div"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center collapsed"
                                        >
                                            <span> Fabric </span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="fabric_div"
                                            aria-labelledby="fabric_div"
                                            class="category_checkbox_show collapsed collapse"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >100% Acrylic dsdfs
                                                        <input
                                                            type="checkbox"
                                                            id="32"
                                                            name="fabricId"
                                                            value="32" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >100% Cotton
                                                        <input
                                                            type="checkbox"
                                                            id="1"
                                                            name="fabricId"
                                                            value="1" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >100% Polyester
                                                        <input
                                                            type="checkbox"
                                                            id="2"
                                                            name="fabricId"
                                                            value="2" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Blends
                                                        <input
                                                            type="checkbox"
                                                            id="6"
                                                            name="fabricId"
                                                            value="6" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Breathable
                                                        <input
                                                            type="checkbox"
                                                            id="13"
                                                            name="fabricId"
                                                            value="13" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Camp
                                                        <input
                                                            type="checkbox"
                                                            id="12"
                                                            name="fabricId"
                                                            value="12" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Compression
                                                        <input
                                                            type="checkbox"
                                                            id="19"
                                                            name="fabricId"
                                                            value="19" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Cotton
                                                        <input
                                                            type="checkbox"
                                                            id="4"
                                                            name="fabricId"
                                                            value="4" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Cotton/Poly
                                                        <input
                                                            type="checkbox"
                                                            id="3"
                                                            name="fabricId"
                                                            value="3" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Denier Polyester
                                                        <input
                                                            type="checkbox"
                                                            id="33"
                                                            name="fabricId"
                                                            value="33" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Denim
                                                        <input
                                                            type="checkbox"
                                                            id="10"
                                                            name="fabricId"
                                                            value="10" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Flannel
                                                        <input
                                                            type="checkbox"
                                                            id="11"
                                                            name="fabricId"
                                                            value="11" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Fleece
                                                        <input
                                                            type="checkbox"
                                                            id="20"
                                                            name="fabricId"
                                                            value="20" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >High Visibility
                                                        <input
                                                            type="checkbox"
                                                            id="30"
                                                            name="fabricId"
                                                            value="30" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Insulated
                                                        <input
                                                            type="checkbox"
                                                            id="23"
                                                            name="fabricId"
                                                            value="23" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Jersey
                                                        <input
                                                            type="checkbox"
                                                            id="31"
                                                            name="fabricId"
                                                            value="31" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Jersey Knit
                                                        <input
                                                            type="checkbox"
                                                            id="25"
                                                            name="fabricId"
                                                            value="25" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Jersey/Mesh
                                                        <input
                                                            type="checkbox"
                                                            id="28"
                                                            name="fabricId"
                                                            value="28" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Mesh
                                                        <input
                                                            type="checkbox"
                                                            id="15"
                                                            name="fabricId"
                                                            value="15" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Micro-mesh
                                                        <input
                                                            type="checkbox"
                                                            id="18"
                                                            name="fabricId"
                                                            value="18" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Nylon
                                                        <input
                                                            type="checkbox"
                                                            id="17"
                                                            name="fabricId"
                                                            value="17" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Oxford
                                                        <input
                                                            type="checkbox"
                                                            id="7"
                                                            name="fabricId"
                                                            value="7" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Pigment-Dyed
                                                        <input
                                                            type="checkbox"
                                                            id="29"
                                                            name="fabricId"
                                                            value="29" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Pique Knit
                                                        <input
                                                            type="checkbox"
                                                            id="24"
                                                            name="fabricId"
                                                            value="24" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Polyester
                                                        <input
                                                            type="checkbox"
                                                            id="5"
                                                            name="fabricId"
                                                            value="5" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Poplin
                                                        <input
                                                            type="checkbox"
                                                            id="8"
                                                            name="fabricId"
                                                            value="8" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Snag Proof
                                                        <input
                                                            type="checkbox"
                                                            id="27"
                                                            name="fabricId"
                                                            value="27" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Snag Resistant
                                                        <input
                                                            type="checkbox"
                                                            id="26"
                                                            name="fabricId"
                                                            value="26" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Soft Shell
                                                        <input
                                                            type="checkbox"
                                                            id="16"
                                                            name="fabricId"
                                                            value="16" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Stain/Soil Resistant
                                                        <input
                                                            type="checkbox"
                                                            id="14"
                                                            name="fabricId"
                                                            value="14" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Stainless Steel
                                                        <input
                                                            type="checkbox"
                                                            id="34"
                                                            name="fabricId"
                                                            value="34" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Twill
                                                        <input
                                                            type="checkbox"
                                                            id="9"
                                                            name="fabricId"
                                                            value="9" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Water Resistant
                                                        <input
                                                            type="checkbox"
                                                            id="22"
                                                            name="fabricId"
                                                            value="22" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        >Wind Resistant
                                                        <input
                                                            type="checkbox"
                                                            id="21"
                                                            name="fabricId"
                                                            value="21" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style=""
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="color_link_1">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#color-div"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center collapsed"
                                        >
                                            <span> Colors </span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="color-div"
                                            aria-labelledby="color-div"
                                            class="category_checkbox_show collapse"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    212,
                                                                    86,
                                                                    86
                                                                );
                                                            "
                                                        ></a>
                                                        Ash
                                                        <input
                                                            type="checkbox"
                                                            id="#D45656"
                                                            name="colorNames"
                                                            value="#D45656" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    182,
                                                                    99,
                                                                    99
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#B66363"
                                                            name="colorNames"
                                                            value="#B66363" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    165,
                                                                    94,
                                                                    94
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#A55E5E"
                                                            name="colorNames"
                                                            value="#A55E5E" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    185,
                                                                    103,
                                                                    103
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#B96767"
                                                            name="colorNames"
                                                            value="#B96767" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    126,
                                                                    76,
                                                                    76
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#7E4C4C"
                                                            name="colorNames"
                                                            value="#7E4C4C" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    165,
                                                                    114,
                                                                    114
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#A57272"
                                                            name="colorNames"
                                                            value="#A57272" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    201,
                                                                    60,
                                                                    60
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#C93C3C"
                                                            name="colorNames"
                                                            value="#C93C3C" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    170,
                                                                    106,
                                                                    106
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#AA6A6A"
                                                            name="colorNames"
                                                            value="#AA6A6A" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    156,
                                                                    54,
                                                                    54
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#9C3636"
                                                            name="colorNames"
                                                            value="#9C3636" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    170,
                                                                    116,
                                                                    116
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#AA7474"
                                                            name="colorNames"
                                                            value="#AA7474" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    216,
                                                                    170,
                                                                    170
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#D8AAAA"
                                                            name="colorNames"
                                                            value="#D8AAAA" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    201,
                                                                    124,
                                                                    124
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#C97C7C"
                                                            name="colorNames"
                                                            value="#C97C7C" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    158,
                                                                    91,
                                                                    91
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#9E5B5B"
                                                            name="colorNames"
                                                            value="#9E5B5B" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    204,
                                                                    77,
                                                                    77
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#CC4D4D"
                                                            name="colorNames"
                                                            value="#CC4D4D" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    0,
                                                                    0,
                                                                    0
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#000000"
                                                            name="colorNames"
                                                            value="#000000" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    255,
                                                                    255,
                                                                    255
                                                                );
                                                            "
                                                        ></a>
                                                        Black
                                                        <input
                                                            type="checkbox"
                                                            id="#FFFFFF"
                                                            name="colorNames"
                                                            value="#FFFFFF" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    74,
                                                                    144,
                                                                    226
                                                                );
                                                            "
                                                        ></a>
                                                        Blue
                                                        <input
                                                            type="checkbox"
                                                            id="#4A90E2"
                                                            name="colorNames"
                                                            value="#4A90E2" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    20,
                                                                    59,
                                                                    238
                                                                );
                                                            "
                                                        ></a>
                                                        Blue
                                                        <input
                                                            type="checkbox"
                                                            id="#143BEE"
                                                            name="colorNames"
                                                            value="#143BEE" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    126,
                                                                    211,
                                                                    33
                                                                );
                                                            "
                                                        ></a>
                                                        Green
                                                        <input
                                                            type="checkbox"
                                                            id="#7ED321"
                                                            name="colorNames"
                                                            value="#7ED321" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    248,
                                                                    231,
                                                                    28
                                                                );
                                                            "
                                                        ></a>
                                                        Orange
                                                        <input
                                                            type="checkbox"
                                                            id="#F8E71C"
                                                            name="colorNames"
                                                            value="#F8E71C" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    255,
                                                                    3,
                                                                    3
                                                                );
                                                            "
                                                        ></a>
                                                        Red
                                                        <input
                                                            type="checkbox"
                                                            id="#FF0303"
                                                            name="colorNames"
                                                            value="#FF0303" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    208,
                                                                    2,
                                                                    27
                                                                );
                                                            "
                                                        ></a>
                                                        Red
                                                        <input
                                                            type="checkbox"
                                                            id="#D0021B"
                                                            name="colorNames"
                                                            value="#D0021B" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                    style="display: none"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                        ><a
                                                            href="javascript:void(0)"
                                                            class="color_circle mr_6"
                                                            style="
                                                                background-color: rgb(
                                                                    217,
                                                                    199,
                                                                    199
                                                                );
                                                            "
                                                        ></a>
                                                        White
                                                        <input
                                                            type="checkbox"
                                                            id="#D9C7C7"
                                                            name="colorNames"
                                                            value="#D9C7C7" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style=""
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="attribute_link_1">
                                        <button
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#attribute-div"
                                            aria-expanded="false"
                                            aria-controls="collapseOne"
                                            class="category_link w-100 d-flex justify-content-center align-items-center collapsed"
                                        >
                                            <span> Other Attributes </span
                                            ><img
                                                src="/maincss/images/plusplus.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion"
                                            /><img
                                                src="/maincss/images/dashh.svg"
                                                alt=" "
                                                class="ml-auto arrow_accordion_white"
                                            />
                                        </button>
                                        <div
                                            id="attribute-div"
                                            aria-labelledby="attribute-div"
                                            class="category_checkbox_show collapsed collapse"
                                            style=""
                                        >
                                            <div class="category_checkbox">
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Features
                                                        <input
                                                            type="checkbox"
                                                            id="9"
                                                            name="attributes"
                                                            value="9" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <div
                                                    class="form-check pl_8 py_6"
                                                >
                                                    <label
                                                        class="checkbox_custom"
                                                    >
                                                        Other Cotton12
                                                        <input
                                                            type="checkbox"
                                                            id="2"
                                                            name="attributes"
                                                            value="2" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                                <a
                                                    class="font_size_13 text_primary_blue btn_link mt_14 pl_8"
                                                    style="display: none"
                                                >
                                                    See more
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-8 col-xl-9">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/product_2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_3.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_4.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/tshirt_product_5.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="product">
                                    <div
                                        class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                    >
                                        <img
                                            src="/maincss/images/product_2.png"
                                            alt=" "
                                            class="img-fluid product_image_main"
                                        /><span
                                            class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                            >-86%</span
                                        >
                                        <div
                                            class="hover_buttons d-inline-flex"
                                        >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/favorite_button.svg"
                                                    alt=" "
                                            /></a>
                                            <a
                                                href="/24hourtshirts"
                                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                ><img
                                                    src="/maincss/images/cart_icon.svg"
                                                    alt=" "
                                                    class="mr_16"
                                                />
                                                Add to cart</a
                                            >
                                            <a
                                                href="#"
                                                class="favorite_button bg_primary_orange py_18 px_18"
                                                ><img
                                                    src="/maincss/images/magnifying-glass.svg"
                                                    alt=" "
                                            /></a>
                                        </div>
                                    </div>
                                    <div class="product_content mt_22">
                                        <h5 class="heading5">
                                            2 Mesh Long Sleeve Tee
                                        </h5>
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                        >
                                            <h6 class="heading6 mb-0">
                                                <span
                                                    class="text_primary_red mr_18"
                                                    >$2.00</span
                                                ><span class="text_light_grey"
                                                    >$3.00</span
                                                >
                                            </h6>
                                            <div class="ml-auto">
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_blue"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_yellow"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_primary_orange"
                                                ></a>
                                                <a
                                                    href="#"
                                                    class="color_circle mr_6 bg_secondary_black"
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <nav
                                    aria-label="Page navigation example"
                                    class="d-flex"
                                >
                                    <ul class="pagination ml-auto mb-0">
                                        <li class="page-item previous">
                                            <a href="#" class="page-link"
                                                ><img
                                                    src="/maincss/images/previous_arrow.svg"
                                                    alt=""
                                                    class="mr_10"
                                                />
                                                Previous</a
                                            >
                                        </li>
                                        <li class="page-item active">
                                            <a href="#" class="page-link">1</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="#" class="page-link">2</a>
                                        </li>
                                        <li class="page-item">
                                            <a href="#" class="page-link">3</a>
                                        </li>
                                        <li class="page-item next active">
                                            <a href="#" class="page-link"
                                                >Next
                                                <img
                                                    src="/maincss/images/next_arrow.svg"
                                                    alt=""
                                                    class="ml_10"
                                            /></a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "CreatedCompanyStore",
    components: {},
    mounted() {
        document.body.classList.add("footer_spacing_mange");
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
